import { FC } from "react";
import ModalComponent from "../../shared/base-components/Modal";

import { Col, Row, Table } from "reactstrap";

import { SupplierDetailModalProps } from "./Supplier.constants";

const SupplierDetailModal: FC<SupplierDetailModalProps> = ({
  userData,
  isModalOpen,
  toggle,
}) => {
  const color = userData?.is_active ? "success" : "danger";

  return (
    <ModalComponent
      header={"Tedarikçi Bilgileri"}
      description={""}
      isOpen={isModalOpen}
      toggle={toggle}
    >
      <Row>
        <Col lg={12}>
          <div className="border rounded">
            <div className="table-responsive">
              <Table className="table-nowrap align-middle mb-0">
                <tbody>
                  <tr key={"key"}>
                    <h5 className="font-size-15 mb-1">{"Adı:"}</h5>

                    <td className="text-start">{userData?.name}</td>
                  </tr>

                  <tr key={"key"}>
                    <h5 className="font-size-15 mb-1">{"Açıklama:"}</h5>

                    <td style={{ whiteSpace: "normal" }} className="text-start">
                      {userData?.description}
                    </td>
                  </tr>

                  <tr key={"key"}>
                    <h5 className="font-size-15 mb-1">{"Telefon:"}</h5>

                    <td className="text-start">{userData?.phone_number}</td>
                  </tr>
                </tbody>
              </Table>
            </div>
          </div>
        </Col>
      </Row>
    </ModalComponent>
  );
};

export default SupplierDetailModal;
